export default {
    data(orderId) {
        return axios.get(`/frontend/order/${orderId}/pay/data`);
    },
}
